import SolutionsHero from './components/SolutionsHero';
import ServicePhilosophy from './components/ServicePhilosophy';
import TargetAudience from './components/TargetAudience';
import ServiceProcess from './components/ServiceProcess';
import MeridianSection from './components/MeridianSection';
import PlanShowcase from './components/PlanShowcase';

export default function SolutionsPage() {
  return (
    <main>
      <SolutionsHero />
      <ServicePhilosophy />
      <TargetAudience />
      <ServiceProcess />
      <MeridianSection />
      <PlanShowcase />
    </main>
  );
}